<template>
    <Paper class="change-notice">
        <div class="change-notice-main">
            <el-form ref="form" :model="changeNewsList"  label-width="0px" :rules="rules">
                <h6 class="company-prefix-title first-title">
                    <span class="company-prefix-title-icon"></span>
                    <span class="company-prefix-title-main">
                        {{$translate('lang.E3202103170007', { defaultText: '标题' })}}
                    </span>
                </h6>
                <div class="change-notice-item">
                    <span class="change-notice-item-title">
                        {{$translate('lang.E3202103170007', { defaultText: '标题' })}}:
                    </span>
                    <span class="change-notice-item-input">
                    <el-form-item prop="subject">
                        <el-input type="text" v-model="changeNewsList.subject" :disabled="checkChange" class="change-notice-item-input-style" maxlength="50"></el-input>
                    </el-form-item>
                    </span>
                </div>
                <div class="change-notice-item">
                    <span class="change-notice-item-title">
                        {{$translate('lang.E3202103170008', { defaultText: '维护类型' })}}:
                    </span>
                    <span class="change-notice-item-input">
                        <el-form-item >
                            <el-select
                                v-model="changeNewsList.contentType"
                                :disabled="checkChange"
                                :placeholder="$translate('lang.E3202103170008', { defaultText: '维护类型' })"
                                style="width:100%"
                                clearable
                                class="change-notice-item-input-style">
                                <el-option :label="$translate('lang.E3202103170010', { defaultText: '最新公告' })" value="1"></el-option>
                                <el-option :label="$translate('lang.E3202103170009', { defaultText: '常见问题' })" value="2"></el-option>
                                <el-option label="内销公告" value="3"></el-option>
                                <el-option label="外销公告" value="4"></el-option>
                            </el-select>
                        </el-form-item>
                    </span>
                </div>
                <div class="change-notice-item">
                    <span class="change-notice-item-title">
                        {{$translate('lang.E3202110200001', { defaultText: '发布时间' })}}:
                    </span>
                    <span class="change-notice-item-input">
                        <el-form-item  prop="pushTime">
                            <el-date-picker
                            type="datetime"
                            v-model="changeNewsList.pushTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :placeholder="$translate('lang.E3202101280018', { defaultText: '选择日期' })">
                            </el-date-picker>
                        </el-form-item>
                    </span>
                </div>
                <h6 class="company-prefix-title first-title">
                    <span class="company-prefix-title-icon"></span>
                    <span class="company-prefix-title-main">
                        {{$translate('lang.E3202103170011', { defaultText: '文本' })}}
                    </span>
                </h6>
                <div class="change-notice-item change-notice-item-top">
                    <span class="change-notice-item-title">
                        {{$translate('lang.E3202103170012', { defaultText: '文本内容' })}}:
                    </span>
                    <richText :maxCount="maxCount" class="change-notice-item-input" ref="textMain"></richText>
                </div>
                <div class="change-notice-item  sn-attachment">
                    <span class="change-notice-item-title">
                        {{$translate('lang.E3202103170013', { defaultText: '附件上传' })}}:
                    </span>
                    <span>
                        <upload-file ref="upload"  @pushImg='pushImg'></upload-file>
                    </span>
                </div>
                <span class="fileName">{{changeNewsList.ossEndpoint}}</span>
                <div class="attachment-shows">
                    <span class="attachment-shows-item1">
                        {{$translate('lang.E3202103170015', { defaultText: '附件说明' })}}:
                    </span>
                    <span class="attachment-shows-item2">
                        <p class="attachment-shows-item2-main">
                            1、{{$translate('lang.E3202103170016', { defaultText: '每个文件不得超过5M，截图请用附件上传' })}}。
                        </p>
                        <p class="attachment-shows-item2-main">
                            2、{{$translate('lang.E3202103170017', { defaultText: '附件格式支持：office、txt、jpg、bmp、rar、zip。其他格式请压缩后上传' })}}。
                        </p>
                    </span>
                </div>
            </el-form>
        </div>
        <div class="change-notice-bottom">
            <el-button class="change-notice-button" size="mini" @click="getBack">
                {{$translate('lang.E3202101270002', { defaultText: '取消' })}}
            </el-button>
            <el-button type="primary" size="mini" class="change-notice-button" @click="save">
                {{$translate('lang.E3202103010008', { defaultText: '保存' })}}
            </el-button>
        </div>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import richText from '../../../components/systemComponent/richText';
import uploadFile from '../../../components/systemComponent/newUploadFile';
import { searchNoticOnce, changeSingleNews, newSingleNews } from '../../../api/systemManagementApi';
export default {
    name: 'changeNotice',
    data() {
        return {
            id: '',
            maxCount: 10000,
            checkChange: false,
            rules: {
                subject: [
                    { required: true, message: this.$translate('lang.E3202103180001', { defaultText: '请输入标题' }), trigger: 'blur' }
                ],
                pushTime: [
                    { required: true, message: this.$translate('lang.E3202103090022', { defaultText: '请选择日期' }), trigger: 'blur' }
                ]
            },
            changeNewsList: {
                subject: '',
                content: '',
                link: '',
                state: 0,
                version: '',
                pushTime: '',
                id: '',
                ossEndpoint: this.$translate('lang.E3202103170014', { defaultText: '暂无上传附件' }),
                contentType: '2'
            },
            copychangeNewsList: {
                subject: '',
                content: '',
                link: '',
                state: 0,
                version: '',
                pushTime: '',
                id: '',
                ossEndpoint: this.$translate('lang.E3202103170014', { defaultText: '暂无上传附件' }),
                contentType: '2'
            },
            start: false
        };
    },
    components: {
        Paper,
        richText,
        uploadFile

    },
    methods: {
        pushImg(affixInf) {
            this.changeNewsList.ossEndpoint = affixInf.localFileName;
            this.changeNewsList.link = affixInf.downUrl;
        },
        // 返回
        getBack() {
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
            Object.keys(this.changeNewsList).forEach(key => {
                this.changeNewsList[key] = this.copychangeNewsList[key];
            });
            this.$refs.textMain.content = null;
            this.$eventBus.$emit('closeTag', this.$route);
            this.$router.go(-1);
        },

        // 保存
        save(value) {
            if (this.$refs.textMain.content) {
                this.changeNewsList.content = this.$refs.textMain.content;
            }
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (this.$route.query.id) {
                        changeSingleNews(this.changeNewsList).then(res => {
                            if (+res.code === 0) {
                                this.$message.success(this.$translate('lang.EXC202102260002', { defaultText: '修改成功' }));
                                this.$eventBus.$emit('closeTag', this.$route);
                                this.$router.go(-1);
                            }
                            this.id = '';
                        });
                    } else {
                        newSingleNews(this.changeNewsList).then(res => {
                            if (+res.code === 0) {
                                this.$message.success(this.$translate('lang.EXC202103010014', { defaultText: '新增成功' }));
                                this.$eventBus.$emit('closeTag', this.$route);
                                this.$router.go(-1);
                            }
                            this.id = '';
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        getPull(id) {
            searchNoticOnce(id).then(res => {
                if (res.code === '0') {
                    Object.keys(this.changeNewsList).forEach(key => {
                        this.changeNewsList[key] = res.data[key];
                    });
                    this.$refs.textMain.content = this.changeNewsList.content;
                }
            });
        }

    },
    created() {
        if (this.$route.query.id) {
            this.getPull(this.$route.query.id);
            this.id = this.$route.query.id;
            this.checkChange = true;
        } else {
            this.changeTemplate = true;
        }
    },
    activated() {
        if (this.$route.query.id) {
            if (this.id !== this.$route.query.id) {
                this.getPull(this.$route.query.id);
                this.id = this.$route.query.id;
                this.checkChange = true;
            }
        } else {
            this.changeTemplate = true;
            this.$refs.textMain.content = null;
            Object.keys(this.changeNewsList).forEach(key => {
                this.changeNewsList[key] = this.copychangeNewsList[key];
            });
            this.checkChange = false;
        }
    },
    deactivated() {
        this.$refs.form.clearValidate();
    }

};
</script>
<style lang="less">
// 页面
.change-notice{
    .fileName{
        margin-left: 80px;
        font-size: 14px;
        color: rgba(0,0,0,0.65);
        line-height: 22px;
    }
    position: relative;
    // 内容部分
    .change-notice-main{
        position: absolute;
        top: 0;
        left: 16px;
        right: 0;
        bottom: 48px;
        overflow: auto;
    }
    .company-prefix-title{
    display: flex;
    align-items: center;
    width: 100%;
    .company-prefix-title-icon{
        width: 2px;
        height: 18px;
        display: inline-block;
        margin-right: 10px;
        background-color:#4285f5;
    }
    .company-prefix-title-main{
        font-size: 16px;
    }
}
    .change-notice-item{
        display: flex;
        width: 60%;
        align-items: center;
        margin: 40px 0;
        .change-notice-item-title{
            width: 70px;
            text-align: right;
            font-size: 14px;
            margin-right: 10px;
        }
        .change-notice-item-input{
            width: calc(100% - 100px);
            .el-form-item{
                margin-bottom: 0;
            }
            .ql-container{
                height: 100px;
            }
        }
    }
    .attachment-shows{
        display: flex;
        width: 60%;
        margin-left: 80px;
        font-size: 12px;
        align-items: flex-start;
        color: rgba(0,0,0,0.45);
        margin-top: 8px;
        margin-bottom: 20px;
        .attachment-shows-item2-main{
            margin: 0px;
            line-height: 16px;
        }

    }
    // 文本域-标题位置
    .change-notice-item-top{
        align-items: flex-start;
    }
    .change-notice-textarea{
        height: 88px;
    }
    // 底部按钮
    .change-notice-bottom{
        height: 48px;
        position: absolute;
        bottom: 0px;
        left: 0;
        right: 0;
        background: #FFFFFF;
        box-shadow: 0 -4px 8px 0 rgba(0,0,0,0.10);
        text-align: right;
        padding-right: 10px;
        box-sizing: border-box;
        .change-notice-button{
            width: 60px;
            margin-top: 12px;
            // width: 88px;
            // height: 32px;
        }
    }
  .sn-attachment{
      margin-bottom: 10px;
      align-items: center;
  }
  .ql-container{
      height: 200px!important;
  }
  .upload-demo{
      .title{
           text-align: left!important;
      }

  }
}
</style>